// // client/src/components/auth/LoginPage.js
// import React, { useState } from 'react';
// import { toast } from 'react-hot-toast';
// import { useAuth } from '../../contexts/AuthContext';
// import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';

// const LoginPage = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const { login } = useAuth();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!email || !password) {
//       toast.error('Please enter both email and password');
//       return;
//     }

//     setLoading(true);
//     try {
//       await login(email, password);
//       // No need for navigation here - it will be handled by the AuthContext
//       navigate('/'); // This will redirect to the root path
//     } catch (error) {
//       toast.error(error.message || 'Failed to log in');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
//       <div className="bg-white rounded-xl shadow-lg border p-8 w-full max-w-md">
//         <div className="text-center mb-8">
//           <h1 className="text-2xl font-bold text-blue-600">Scraper Pro</h1>
//           <p className="text-gray-500 text-sm mt-2">Login to access your leads</p>
//         </div>
        
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                 <FaEnvelope className="text-gray-400" />
//               </div>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="pl-10 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Your email address"
//                 disabled={loading}
//               />
//             </div>
//           </div>
          
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                 <FaLock className="text-gray-400" />
//               </div>
//               <input
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="pl-10 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="Your password"
//                 disabled={loading}
//               />
//             </div>
//           </div>
          
//           <button
//             type="submit"
//             disabled={loading}
//             className={`w-full py-2 px-4 rounded-md text-white ${
//               loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
//             } flex items-center justify-center gap-2`}
//           >
//             {loading ? (
//               <>
//                 <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
//                 <span>Logging in...</span>
//               </>
//             ) : (
//               <>
//                 <FaSignInAlt className="text-lg" />
//                 <span>Login</span>
//               </>
//             )}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// client/src/components/auth/LoginPage.js
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { login } = useAuth();
  const navigate = useNavigate();

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Check email
    if (!email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!validateEmail(email)) {
      newErrors.email = 'Please enter a valid email address';
      isValid = false;
    }

    // Check password
    if (!password.trim()) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else if (password.length < 4) {
      newErrors.password = 'Password must be at least 4 characters';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setErrors({});
    
    // Validate form
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const response = await login(email, password);
      
      if (response?.success) {
        navigate('/'); // Navigate to the root path after successful login
      }
    } catch (error) {
      const errorMsg = error.message || 'Authentication failed';
      
      // Check if it's a credential error (usually 401)
      if (errorMsg.includes('Invalid email or password') || error.status === 401) {
        toast.error('Invalid email or password');
        setErrors({ auth: 'The email or password you entered is incorrect' });
      } else {
        toast.error(errorMsg);
        setErrors({ auth: 'Failed to login. Please try again later.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg border p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-blue-600">Scraper Pro</h1>
          <p className="text-gray-500 text-sm mt-2">Login to access your leads</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Authentication error message */}
          {errors.auth && (
            <div className="bg-red-50 border-l-4 border-red-500 p-3 rounded">
              <p className="text-red-700 text-sm">{errors.auth}</p>
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaEnvelope className="text-gray-400" />
              </div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`pl-10 w-full border ${
                  errors.email ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
                } rounded-md px-3 py-2 focus:outline-none focus:ring-2`}
                placeholder="Your email address"
                disabled={loading}
              />
            </div>
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email}</p>
            )}
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaLock className="text-gray-400" />
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`pl-10 w-full border ${
                  errors.password ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
                } rounded-md px-3 py-2 focus:outline-none focus:ring-2`}
                placeholder="Your password"
                disabled={loading}
              />
            </div>
            {errors.password && (
              <p className="mt-1 text-sm text-red-600">{errors.password}</p>
            )}
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 rounded-md text-white ${
              loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
            } flex items-center justify-center gap-2`}
          >
            {loading ? (
              <>
                <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                <span>Logging in...</span>
              </>
            ) : (
              <>
                <FaSignInAlt className="text-lg" />
                <span>Login</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;